import { Component, Input, OnInit } from '@angular/core';
import { BrPageComponent } from '@bloomreach/ng-sdk';
import { Page } from '@bloomreach/spa-sdk';
import { ViewModeService } from '@services/view-mode.service';

@Component({
  selector: 'ft-emea-layout',
  templateUrl: './emea-layout.component.html',
  styleUrls: ['./emea-layout.component.scss'],
})
export class EmeaLayoutComponent {
  /**
   * Bloomreach page object
   */
  @Input() page!: Page;

  /**
   * Component configuration
   */
  public configuration: BrPageComponent['configuration'];

  public isEditMode = false;

  constructor(private viewModeService: ViewModeService) {
    this.isEditMode = this.viewModeService.isEditMode();
  }
}
